// Custom
import ApartmentsForm from "new_design/common/search_widget/search_form/apartments";
import { popupSliderTnsInit } from 'new_design/desktop/common/sliders';
import { popupInit } from 'new_design/desktop/common/popup';
import { preventEmptyHrefDefault } from "new_design/common/prevent_empty_href_default";
import { setNavElementEvents } from "new_design/desktop/camps/show/nav";
import $ from "jquery";
import FunnySadDialog from "../../../../funny-sad-dialog";
import {hideOtherTariffs} from "../../../../camps/show/utils";
import DatePicker from "../../../date-picker";
import GuestsWidget from "../../../guests";


class ApartmentsFormDesktop extends ApartmentsForm {
  static async init (formId, options) {
    let form = new ApartmentsFormDesktop(formId, options);
    await form._init();
    return form;
  }

  constructor(formId, options = {}) {
    super(formId, options);
    this.$loadFromTLBtn = this.$form.find('#apartments_load_from_travel_line');
    this._initTlBtn();
    this.datePicker =
      new DatePicker(formId, {
        dateStart: '#apartments_date_start',
        dateEnd: '#apartments_date_end',
        dateRange: '#apartments_dates',
        nightsCount: '#apartments_nights_count',
        isBookingByDay: this.$form.find("input[name='is_booking_by_day']").val() === 'true',
        firstPreview: false,
        campId: this.$form.find("input[name='search_id']").val(),
        onUpdate: () => { this.refresh(); }
      });
    window.apartmentsDatePicker = this.datePicker;
    this.guestsWidget =
      new GuestsWidget(formId, {
        childrenAges: 'apartments_children_ages',
        childrenCount: 'apartments_children_count',
        countGuests: 'apartments_count_guests',
        guestChildNumber: 'apartments_guest-child-number',
        totalAdultsCount: 'apartments_total_adults_count',
        totalChildrenCount: 'apartments_total_children_count',
      });
  }

  _initTlBtn () {
    this.$loadFromTLBtn.on("click", () => {
      let date_start = this.$form.find("input[name='date_start']").val();
      let date_end = this.$form.find("input[name='date_end']").val();
      if (!date_end || !date_start) {
        FunnySadDialog.createFunnyDialog('Сначала выберите даты.', '');
        return;
      }
      this.$loadFromTLBtn.prop('disabled', true).find('.loading__img').show();
      let children_ages = [];
      this.$form.find("input[name='children_ages[]']").each((i, el) => children_ages.push($(el).val()))
      $.ajax({
        url: `/travel_line/travel_line_offers`,
        type: 'GET',
        data: {
          camp_id: this.$form.find("input[name='search_id']").val(),
          date_start: date_start,
          date_end: date_end,
          count_guests: this.$form.find("#apartments_count_guests").val(),
          children_ages: children_ages
        },
        success: (res) => {
          this.$dataField.find("#travel_line_offers").remove();
          this.$dataField.prepend(res);
          this.$loadFromTLBtn.prop('disabled', false).find('.loading__img').hide();
          hideOtherTariffs();
          this._eventsInit();
        },
        error: () => {
          this.$loadFromTLBtn.prop('disabled', false).find('.loading__img').hide();
          FunnySadDialog.createSadDialog(
            'Произошла ошибка.',
            'Вероятно на сайте нет виджета TL или он недоступен. Проверьте ссылку на сайт'
          );
        }
      })
    })
  }

  _ajaxInit() {
    super._ajaxInit();

    this.$form.on('ajax:complete', preventEmptyHrefDefault);
  }

  _eventsInit () {
    super._eventsInit();

    popupInit(); // Для работы модалки апартамента
    if (!this.loaded) {
      let apartment_id = window.location.hash.substring(1);
      $('#apartment-' + apartment_id + '-name').click();
      this.loaded = true;
    }

    $('.open_popup[rel^="room-info"]').click(function () {
      $('#' + $(this).attr('rel')).find('.apartment_modal_lazy').each(function (i, elem) {
        $(elem).prop('src', $(elem).data('src'));
      })
      popupSliderTnsInit();
    })

    setNavElementEvents(
      document.querySelectorAll('.popup-nav .popup-nav__list > .popup-nav__list-item'),
      'popup-nav__list-item_active'
    );
  }
}

export default ApartmentsFormDesktop;
